export default __webpack_public_path__ + "static/media/kyle.18ef9971.webp";